module.exports = __webpack_public_path__ + "img/HelpIcon.737c6bd0.svg";